<template>
  <div>
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:default>
        <div class="flex flex-col max-w-xl mx-auto my-10">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div
              class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow"
            >
              <div class="px-4 py-5 sm:px-6">
                <!-- Content goes here -->
                <!-- We use less vertical padding on card headers on desktop than on body sections -->
                <legend class="text-sm font-semibold leading-6 text-gray-900">
                  Prompt
                </legend>
                <p class="mt-1 text-sm leading-6 text-gray-600">
                  Configure the opt-in prompt shown for your store visitors.
                </p>
              </div>
              <div class="px-4 py-5 sm:p-6">
                <fieldset>
                  <div class="mt-6 space-y-6">
                    <div class="relative flex gap-x-3">
                      <div class="flex h-6 items-center">
                        <input
                          id="browserPrompt"
                          name="push-notifications"
                          value="browser"
                          v-model="widgetConfig.promptType"
                          @input="updateOptinConfig"
                          type="radio"
                          class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                      </div>
                      <div class="text-sm leading-6">
                        <label
                          for="browserPrompt"
                          class="font-medium text-gray-900"
                          >Browser prompt</label
                        >
                        <p class="text-gray-500">
                          Use the default browser optin panel
                        </p>
                      </div>
                    </div>

                    <div class="relative flex gap-x-3">
                      <div class="flex h-6 items-center">
                        <input
                          id="customPrompt"
                          name="push-notifications"
                          value="custom"
                          v-model="widgetConfig.promptType"
                          @input="updateOptinConfig"
                          type="radio"
                          class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                      </div>
                      <div class="text-sm leading-6">
                        <label
                          for="customPrompt"
                          class="font-medium text-gray-900"
                          >Custom Prompt
                          <button
                            class="Polaris-Button"
                            type="button"
                            @click="gotoEditCustom"
                          >
                            <span class="Polaris-Button__Content">
                              <span class="Polaris-Button__Text">Edit</span>
                            </span>
                          </button>
                        </label>
                        <p class="text-gray-500">
                          Use the Customized optin panel
                        </p>
                      </div>
                    </div>
                    <div class="relative flex gap-x-3">
                      <div class="flex h-6 items-center">
                        <input
                          id="noPrompt"
                          name="push-notifications"
                          v-model="widgetConfig.promptType"
                          @input="updateOptinConfig"
                          value="none"
                          type="radio"
                          class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                      </div>
                      <div class="text-sm leading-6">
                        <label for="noPrompt" class="font-medium text-gray-900"
                          >No Prompt</label
                        >
                        <p class="text-gray-500">
                          Optin prompt won’t be shown to your store visitors.
                        </p>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
// import Spinner from "vue-simple-spinner";

import Page from "../../components/Common/Page";

export default {
  name: "Optin",

  data() {
    return {
      pageTitle: "Optin",
      isLoading: false,
      currentCustomerPhoneNumber: null,
      showCustomerInfoModal: false,
      products: {},
      welcomeNotificationConfig: {},
      widgetConfig: {}
    };
  },
  components: {
    Page
    // Spinner
  },
  computed: {
    config() {
      return this.$store.getters.getConfig;
    }
  },
  created() {
    this.$store.dispatch("getConfig");
    this.getOptinConfig();
  },
  mounted() {},
  methods: {
    async getOptinConfig() {
      this.isLoading = true;
      this.$store.dispatch("getOptinConfig").then(response => {
        this.widgetConfig = response.config;
        this.isLoading = false;
      });
    },
    updateOptinConfig() {
      this.$store
        .dispatch("updateOptinConfig", {
          requestParams: this.widgetConfig
        })
        .then(() => {
          this.$store.dispatch("showNotification", {
            text: "Settings Updated"
          });
        });
    },
    gotoEditCustom() {
      this.$router.push({ name: "EditCustomOptin" });
    }
  }
};
</script>

<style lang="scss" scoped></style>
